import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSerializer  } from '@angular/router';
import { AppComponent } from './app.component';
import { urlParamsResolver } from './_resolvers/url-params.resolver';
import { RenderMode, ServerRoute } from '@angular/ssr';


const routes: Routes = [
  {
    path: '**',
    component: AppComponent,
    resolve: {  
      urlParams: urlParamsResolver
    }
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
